import type { ReadonlyRecord } from "../types/index.ts";

export function findIntersectionKeys(
  ...objects: readonly object[]
): readonly string[] {
  const keys = new Map<string, number>();

  for (const obj of objects) {
    for (const key in obj) {
      if (Object.hasOwn(obj, key)) {
        keys.set(key, (keys.get(key) ?? 0) + 1);
      }
    }
  }

  return [...keys.entries()]
    .filter(([_, count]) => count === objects.length)
    .map(([key]) => key);
}

export function omitUndefined<T extends ReadonlyRecord<string, unknown>>(
  obj: T,
): Partial<T> {
  const result: Partial<T> = {};

  for (const key in obj) {
    // oxlint-disable-next-line custom/no-nullish-comparison
    if (Object.hasOwn(obj, key) && obj[key] !== undefined) {
      result[key] = obj[key];
    }
  }

  return result;
}
